import React, { FC } from 'react'
import Pagination from 'components/SA/Pagination'
import ResultsCount from 'components/SA/Pagination/ResultsCount'
import AlgoliaConnector, { ConnectorProps as AlgoliaProps } from 'connectors/Algolia/Algolia'
import URLConnector, { ConnectorProps as URLProps } from '../connectors/Url'
import PaginationConnector, { ConnectorProps as PaginationProps } from '../connectors/Pagination'
import { updateFeatureUrl } from '../helpers/url'
import SelectHitsPerPage from '../components/SelectHitsPerPage'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import styles from './FeaturePagination.module.scss'

type FeaturePaginationProps = AlgoliaProps & URLProps & PaginationProps

const FeaturePagination: FC<FeaturePaginationProps> = (props) => {
  const { hitsPerPage, hitsTotal, currentPage, totalPages, getHref, category } = props

  return (
    <div className={styles.paginationContainer}>
      <Pagination
        current={currentPage + 1}
        total={totalPages}
        onClickLink={({ currentHref }) => {
          handleScrollToTop(() => {
            updateFeatureUrl(currentHref)
          })
        }}
        urlWithParam={getHref}
      />
      <ResultsCount
        hitsTotal={hitsTotal}
        hitsPerPage={hitsPerPage}
        category={category}
        currentPage={currentPage}
      />
      {!!hitsTotal && <SelectHitsPerPage />}
    </div>
  )
}

export default AlgoliaConnector(URLConnector(PaginationConnector(FeaturePagination)))
